import { FC } from "react";
import CallOutlineIcon from "@ht/shared/fonts/deos-pis/call-outline";
import ChatOutlineIcon from "@ht/shared/fonts/deos-pis/chat-outline";
import VideoOutlineIcon from "@ht/shared/fonts/deos-pis/video-outline";

const Circle: FC = ({ children }) => {
    return <div className="rounded-full p-5 bg-primary-50">{children}</div>;
};
const EmptyMessage: FC = () => {
    const threeDot = (
        <div className="mx-4 flex justify-center items-center">
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary mx-4" />
            <div className="min-w-[6px] min-h-[6px] rounded-full bg-primary" />
        </div>
    );
    return (
        <div className="flex flex-col items-center justify-center">
            <div className="flex justify-center">
                <Circle>
                    <ChatOutlineIcon className="text-primary" />
                </Circle>
                {threeDot}
                <Circle>
                    <CallOutlineIcon className="text-primary" />
                </Circle>
                {threeDot}
                <Circle>
                    <VideoOutlineIcon className="text-primary" />
                </Circle>
            </div>
            <div className="text-gray-700 font-bold text-[20px] mt-8 ">
                Arsi Agent Web
            </div>
            <div className=" mt-3 text-gray-400 text-md font-normal text-center">
                Accept or start a chat, call & video call with users and help
                them <br />
                with their problems.
            </div>
        </div>
    );
};

export default EmptyMessage;
